<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title mb-0">Departamentos</h1>
    </div>

    <div class="table-container">
      <ubigeo-table-header @reload="loadData()" />

      <div class="table-responsive mb-0 table-min-height">
        <table class="custom-table w-100">
          <thead>
            <tr>
              <th class="pl-3">Departamento</th>
              <th>Provincias</th>
              <th>Distritos activos</th>
              <th class="pr-md-4">Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="d in rows" :key="d.departamento">
              <td class="pl-3 font-weight-bold">{{ titleCase(d.departamento) }}</td>
              <td class="text-center">{{ d.provincias }}</td>
              <td class="text-center">
                <span :class="{ 'text-success font-weight-bold': d.activos > 0 }">{{ d.activos }}</span>
                <span class="text-muted"> / {{ d.total }}</span>
              </td>
              <td class="text-center pr-md-3">
                <button class="button button-light" @click="goProvincias(d.departamento)">
                  Ver provincias <i class="ri-arrow-right-line"></i>
                </button>
              </td>
            </tr>
            <tr v-if="!rows.length">
              <td colspan="4" class="text-center text-muted py-4">Sin departamentos.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Alert } from 'wize-admin'
import { UbigeoService } from '@/core/services'
import UbigeoTableHeader from '../Components/UbigeoTableHeader.vue'

export default {
  name: 'DepartmentList',
  components: { UbigeoTableHeader },
  data() {
    return { rows: [] }
  },
  methods: {
    titleCase(s) {
      if (!s) return ''
      return String(s).toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())
    },
    goProvincias(dept) {
      this.$router.push({ name: 'ubigeo-provincias', params: { dept } })
    },
    async loadData() {
      try {
        await this.$store.dispatch('app/loading', true)
        const res = await UbigeoService.departamentos()
        this.rows = res.payload || []
      } catch (e) {
        console.error(e)
        Alert.error(e.errors ? e.errors.message : 'Error al obtener departamentos')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    }
  },
  async mounted() {
    await this.loadData()
  }
}
</script>
